import { Icon } from './_Icon';
export const DashboardIcon = (props) => (
  <Icon {...props} d="M3 3v18h18 M7 14l4-4 4 3 5-7" />
);
